import type { AppConfiguration, WebChatForms, FormValidator } from '../types';
import type { WebChatFormJSON } from '../types/WebChatFormJSON';

const requiredValidator =
  (customerId: number): FormValidator =>
  (_, __, input) =>
    customerId > 0 ? true : !!input?.val();

export const getWebChatForms = (
  { firstName: firstname, lastName: lastname, email, customerId }: AppConfiguration,
  customForm = true,
): WebChatForms => {
  const formJSON = {
    wrapper: '<table></table>',
    inputs: [
      {
        id: 'cx_webchat_form_firstname',
        name: 'firstname',
        maxlength: '100',
        placeholder: '@i18n:webchat.ChatFormPlaceholderFirstName',
        label: '@i18n:webchat.ChatFormFirstName',
        validate: requiredValidator(customerId),
      },
      {
        id: 'cx_webchat_form_lastname',
        name: 'lastname',
        maxlength: '100',
        placeholder: '@i18n:webchat.ChatFormPlaceholderLastName',
        label: '@i18n:webchat.ChatFormLastName',
        validate: requiredValidator(customerId),
      },
      {
        id: 'cx_webchat_form_email',
        name: 'email',
        maxlength: '100',
        placeholder: '@i18n:webchat.ChatFormPlaceholderEmail',
        label: '@i18n:webchat.ChatFormEmail',
      },
    ],
  };

  return {
    form: {
      autoSubmit: customerId > 0,
      firstname,
      lastname,
      email,
      subject: 'general questions',
    },
    formJSON: (customForm ? formJSON : {}) as WebChatFormJSON,
  };
};
